import { atom } from 'recoil';

export const deformedPreviewProgressState = atom<{
    done: number;
    total: number;
} | null>({
    key: 'deformedPreviewProgressState',
    default: null,
});

export const deformedPreviewCoverageState = atom<number | null>({
    key: 'deformedPreviewCoverageState',
    default: null,
});
